import JSZip from 'jszip';
import pdfjsLib from 'pdfjs-dist';

import getFileAsBinary from '@/utils/fileGetAsBinary';

/**
 * Gets the number of pages in a PDF or PPTX file.
 *
 * @async
 * @throws {Error}
 *
 * @param {File} file - The file object to retrieve the number of pages from.
 * @returns {Promise<number|null>} - A promise that resolves with the number of pages
 *    in the file or null if the file is not a PDF or PPTX.
 */
export default async function (file) {
  const binaryFile = await getFileAsBinary(file);
  // Check if the file is a PDF
  if (file.type === 'application/pdf') {
    const pdfDoc = await pdfjsLib.getDocument({ data: binaryFile }).promise;
    return pdfDoc.numPages;
  }
  // Check if the file is a PPTX
  if (file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
    const zip = await JSZip.loadAsync(binaryFile);
    const slideFiles = Object.keys(zip.files).filter(name => name.startsWith('ppt/slides/slide'));
    return slideFiles.length;
  }
  // Return null for unsupported file types
  return null;
}
